import { getAuthToken } from "./auth";
import { withVetcanApiBase } from "./apiBase";

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  const token = (getAuthToken() || "").trim();

  if (token) {
    headers.set(
      "Authorization",
      token.startsWith("Bearer ") ? token : `Bearer ${token}`
    );
  }

  const response = await fetch(withVetcanApiBase(input), { ...init, headers });

  if (response.status === 401 || response.status === 403) return response;
  return response;
}